mutation DisconnectPayPal {
  disconnectPayPal {
    id
    paymentSettings {
      provider
      paypal {
        clientId
        webhookUrl
        sandbox
        connectedAt
      }
    }
  }
}
